export const removeElementFromDom = ele => {
  if (ele) {
    if (!('remove' in Element.prototype)) {
      try {
        ele.parentNode.removeChild(ele)
      } catch (e) {
        console.exception(e)
      }
    } else {
      try {
        ele.remove()
      } catch (e) {
        try {
          ele.parentNode.removeChild(ele)
        } catch (e2) {
          console.log(e2)
        }
      }
    }
  }
}

export const removeCss = cssId => {
  removeElementFromDom(document.getElementById(cssId))
}

export const addCss = (cssId, href) => {
  removeCss(cssId)
  const ele = document.createElement('link')
  ele.setAttribute('id', cssId)
  ele.setAttribute('type', 'text/css')
  ele.setAttribute('rel', 'stylesheet')
  ele.setAttribute('media', 'all')
  ele.setAttribute('href', href)
  document.body.appendChild(ele)
}

export const loadPartnerCss = (aid, lang) => {
  addCss(aid, `${process.env.VUE_APP_API_ENDPOINT}/${lang || 'en'}/api/${aid}/affiliate.css`)
}
